export const ClaimTrackingStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    padding: "20px 0",
  },
  headerContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "24px",
    backgroundColor: "var(--white)",
    padding: "24px",
    borderRadius: "8px",
    
  },
  headingContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  heading: {
    color: "var(--primary-black)",
    fontSize: "16px",
    fontFamily: "var(--font-noto-sans)",
    fontWeight: "400",
    lineHeight: "22px",
  },
  subheading: {
    color: "var(--secondary-grey)",
    fontSize: "14px",
    fontFamily: "var(--font-noto-sans)",
    fontWeight: "400",
    lineHeight: "19px",
  },
  timeLineContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  timeLineRightContent: {
    width: "100%",
  },
  headingText: {
    fontSize: "20px",
    fontFamily: "var(--font-playfair)",
    color: "var(--primary-black)",
    fontWeight: "800",
    marginBottom: "24px",
  },
  verificationBadge: {
    backgroundColor: "var(--light-blue)",
    color: "var(--primary-blue)",
    padding: "4px 12px",
    borderRadius: "16px",
    display: "inline-flex",
    alignItems: "center",
    fontSize: "14px",
    fontFamily: "var(--font-noto-sans)",
  },
  detailsContainer: {
    backgroundColor: "var(--white)",
    borderRadius: "8px",
    padding: "24px",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.23)",
    border: "1px solid var(--border-grey)",
  },
  detailsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "24px",
  },
  detailItem: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  detailLabel: {
    color: "var(--secondary-grey)",
    fontSize: "14px",
    fontFamily: "var(--font-noto-sans)",
    fontWeight: "400",
  },
  detailValue: {
    color: "var(--primary-black)",
    fontSize: "16px",
    fontFamily: "var(--font-noto-sans)",
    fontWeight: "400",
  },
  timelineSection: {
    marginTop: "40px",
  },
  timelineTitle: {
    fontSize: "20px",
    fontFamily: "var(--font-playfair)",
    color: "var(--primary-black)",
    fontWeight: "600",
    marginBottom: "24px",
  },
  divider: {
    height: "1px",
    backgroundColor: "var(--border-grey)",
    margin: "24px 0",
  }
};
